import PriceTypesService from '@/services/codebooks/PriceTypesService'

export default {
  namespaced: true,
  state: {
    priceTypesList: []
  },
  getters: {
    priceTypesList: state => state.priceTypesList
  },
  actions: {
    refreshPriceTypes ({ commit }) {
      return PriceTypesService.getAllPriceTypes()
        .then(list => {
          commit('SET_PRICE_TYPES', list)
        })
    }
  },
  mutations: {
    SET_PRICE_TYPES (state, list) {
      state.priceTypesList = list
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/codebook/priceTypes.js